export class Booking {
    constructor() {
        this.phone = '';
        this.whatsapp = '';
        this.mail = '';
    }
}